<template>
  <span>
    <span v-if="status === 'saving'">(儲存中...)</span>
    <span v-else-if="status === 'saved'">(已儲存)</span>
    <span v-else-if="status === 'failed'">(儲存失敗)</span>
  </span>
</template>

<script>
export default {
  props: {
    status: String,
    text: String
  }
}
</script>
